import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
export const fetchPropertyDefinitions = async objectTypeId => {
  const results = await getFrameworkDataSchemasClient().then(client => client.properties.get({
    frameworkTypeIdentifier: objectTypeId
  }));
  return results;
};